export const environment = {
  name: 'stage',
  production: true,
  APP: {
    API_URL                   : 'https://maps.stg.propertycapsule.com/api',
    WEB_APP_URL               : 'https://maps.stg.propertycapsule.com',
    EMBED_APP_URL             : 'https://maps.stg.propertycapsule.com/embed-app/index.html?m=',
    DOMAIN                    : '.propertycapsule.com',
    AUTH_URL                  : 'https://maps.stg.propertycapsule.com/auth',
    INSPECLET_ID              : '580271572',
    //SEGMENT_TRACKING        : '8JvPE5JTxydUl0DNCknjDbWpKJH6Ckql', //Uncomment this to track segment on dev source
    SEGMENT_TRACKING          : false,
    TOURBOOK_WEB_URL          : 'https://maps.stg.propertycapsule.com/tourbooks/',
    SEARCH_WEB_APP_URL        : 'https://search.stg.propertycapsule.com',
    TOURS_WEB_APP_URL         : 'https://tours.stg.propertycapsule.com/',
    ADMIN_WEB_APP_URL         : 'https://admin.propertycapsule.com',
    SUPPORT_EMAIL             : 'support@propertycapsule.com',
    GOOGLE_CLIENT_ID          : 'gme-propertycapsuleinc',
    JLL: {
      DOMAIN: '.stg.requantive.com',
      HOSTNAME: 'tourpointappmaps.stg.requantive.com',
      WEB_APP_URL: 'https://tourpointapp.stg.requantive.com/',
      CAPSULE_MAPS_WEB_URL: 'https://tourpointappmaps.stg.requantive.com/',
      SUPPORT_EMAIL: 'tourpoint@am.jll.com'
    }
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts